import React from 'react';

import './StepBadge.css';

const StepBadge = ({ number, label }) => (
  <div className="StepBadge">
    <span className="StepBadgeNumber">{number}</span>
    <span className="StepBadgeLabel">{label}</span>
  </div>
);

export default StepBadge;
